import React from 'react';
import Proptypes from 'prop-types';
import _ from 'lodash';
import { getSaxsExtendedMergesByMergeIds, getSaxsDataCollectionsAsBeanByDataCollectionIds } from './IORequests';
import { FRAME_SCALE_LOG, AVERAGE_BUFFER_FRAME_TYPE, AVERAGE_SAMPLE_FRAME_TYPE, SUBTRACTED_FRAME_TYPE, BUFFER_OR_SAMPLE_FRAME_TYPE } from '../../../constants/saxs';
import { parseMerges } from '../../../helpers/Saxs/SaxsMergesMapper';
import { parseDataCollectionAsBean } from '../../../helpers/Saxs/SaxsDataCollectionMapper';

/**
 * React container which handle a frame list
 */
class SaxsFrameListContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dataCollectionSubtractions: [],
            frameList: [],
            fetching: true,
            fetched: false,
            selectedFrames: [],
            scale: FRAME_SCALE_LOG,
        }

        this.getFrames = this.getFrames.bind(this);
        this.onScaleChanged = this.onScaleChanged.bind(this);
        this.onFrameClicked = this.onFrameClicked.bind(this);
    }
    render() {
        let { dataCollectionSubtractions } = this.props;

        if (dataCollectionSubtractions && dataCollectionSubtractions.length > 0) {
            if (!_.isEqual(this.state.dataCollectionSubtractions, dataCollectionSubtractions)) {
                this.getFrames()
            }
        }

        return this.props.children(this.state.frameList, this.state.selectedFrames, this.onFrameClicked, this.state.scale, this.onScaleChanged);
    }

    /** Get the frames. 
     * First get all the frames (discarded and not discarded) via the 'merge' call. 
     * Then go for 'dataCollection as bean' call to get none discarded buffer and sample frames as 
     * well as additional frames (sample average , buffer average and subtraction frames)
     */
    getFrames() {

        const onSuccess = (response) => {
            let merges = parseMerges(response.data); // array of merge
            let allFrames = _.flatten(_.map(_.map(merges, 'frameList'), 'frames'));

            const onSuccess2 = (response) => {
                let dataCollection = parseDataCollectionAsBean(response.data);
                if (dataCollection && dataCollection.subtraction) {
                    let subtraction = dataCollection.subtraction;

                    let bufferFramesNotDiscarded = subtraction.bufferFrameList ? subtraction.bufferFrameList.frames : [];
                    let sampleFramesNotDiscarded = subtraction.sampleFrameList ? subtraction.sampleFrameList.frames : [];

                    /** Identify discarded frames */
                    for (let i = 0; i < allFrames.length; i++) {
                        let frame = allFrames[i];
                        frame.discarded = _.find(_.concat(bufferFramesNotDiscarded, sampleFramesNotDiscarded), f => { debugger; return f.frameId === frame.frameId }) ? false : true;
                        frame.type = BUFFER_OR_SAMPLE_FRAME_TYPE;
                    }

                    allFrames = _.orderBy(allFrames, ['filePath'], ['asc']);
                    allFrames.unshift({
                        filePath: subtraction.subtractedFilePath,
                        frameId: subtraction.subtractionId,
                        type: SUBTRACTED_FRAME_TYPE
                    });
                    allFrames.unshift({
                        filePath: subtraction.bufferAverageFilePath,
                        frameId: subtraction.subtractionId,
                        type: AVERAGE_BUFFER_FRAME_TYPE
                    });
                    allFrames.unshift({
                        filePath: subtraction.sampleAverageFilePath,
                        frameId: subtraction.subtractionId,
                        type: AVERAGE_SAMPLE_FRAME_TYPE
                    });

                    this.setState({
                        fetched: true,
                        fetching: false,
                        frameList: allFrames,
                        dataCollectionSubtractions: this.props.dataCollectionSubtractions
                    })
                }
            }

            const onError2 = (error) => {

            }

            getSaxsDataCollectionsAsBeanByDataCollectionIds(this.props.token, this.props.proposal, this.props.dataCollectionId, onSuccess2, onError2);
        }

        const onError = (error) => {
            debugger;
        }

        let mergeIds = _.map(this.props.dataCollectionSubtractions, subtraction => subtraction.merge_id);
        getSaxsExtendedMergesByMergeIds(this.props.token, this.props.proposal, mergeIds.join(), onSuccess, onError);
    }


    /**
     * Callback function triggered when the user clicked on the frame in the list
     * @param {int} frameId 
     * @param {string} frameType
     */
    onFrameClicked(frameId, frameType) {
        let foundFrame = _.find(this.state.selectedFrames, frame => frame && frame.frameId && frame.frameId === frameId && frame.type === frameType);

        if (foundFrame) {
            // remove the frame from the selectedFrames array
            this.setState({ selectedFrames: this.state.selectedFrames.filter(frame => frame.frameId !== frameId) })
        } else {
            // add frameId in the selectedFramesIds array
            let newList = _.cloneDeep(this.state.selectedFrames);
            let frameToAdd = _.find(this.state.frameList, frame => frame && frame.frameId && frame.frameId === frameId && frame.type === frameType);

            newList.push(frameToAdd);
            this.setState({ selectedFrames: newList })
        }
    }

    onScaleChanged(newScale) {
        if (this.state.scale !== newScale) { this.setState({ scale: newScale }) };
    }
}

export default SaxsFrameListContainer;

SaxsFrameListContainer.proptypes = {
    /** datacollection identifier */
    dataCollectionId: Proptypes.number,
    /** all subtractions for the given dataCollection */
    dataCollectionSubtractions: Proptypes.array,
    /** proposal name */
    proposal: Proptypes.string,
    /** ispyb authentication token */
    token: Proptypes.string,
}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsFrameListContainer.js